import { createSlice } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

const initialState = {
  answersArray: [],
  currentQuestionIndex: 0,
  isStarted: false,
};

const riskAssessmentSlice = createSlice({
  name: "riskAssessment",
  initialState,
  reducers: {
    setAnswer: (state, action) => {
      const { question_id, option_order } = action.payload;
      const existingIndex = state.answersArray.findIndex(
        (item) => item.question_id === question_id
      );

      if (existingIndex !== -1) {
        state.answersArray[existingIndex] = { question_id, option_order };
      } else {
        state.answersArray.push({ question_id, option_order });
      }
      state.isStarted = true;
    },
    setIndex: (state, action) => {
      state.currentQuestionIndex = action.payload;
    },
    startAssessment: (state) => {
      state.isStarted = true;
    },
    resetAssessment: (state) => {
      state.answersArray = [];
      state.currentQuestionIndex = 0;
      state.isStarted = false;
    },
  },
});

export const { setAnswer, setIndex, startAssessment, resetAssessment } =
  riskAssessmentSlice.actions;

const persistConfig = {
  key: "riskAssessment",
  storage,
};

export default persistReducer(persistConfig, riskAssessmentSlice.reducer);
